import { mergedDataContract } from './mergedData.contract';
import { mobileWorkersContract } from './mobile.contract';

// Individual re-exports (for route files importing specific contracts)
export {
	mergedDataContract,
	equipmentStreamRoute,
	floorsStreamRoute,
	dashboardDataStreamRoute,
} from './mergedData.contract';
export { mobileWorkersContract } from './mobile.contract';

// Aggregated export for service client creation
export const locationEngineContracts = {
	mergedDataContract,
	mobileWorkersContract,
};
